import { BReactComponent } from 'blocks-cloud/b-react-component/b-react-component';
import { getInitialId, goTo } from 'reactApp/appHelpers/appHelpers';
import { ROOT_FOLDER_ID } from 'reactApp/constants/magicIdentificators';
import { DataList } from 'reactApp/ui/Datalist/DataList';

export class DataListController {
    private currentModeExt: string | undefined;
    private datalist: any;

    public render(el, props = {}): void {
        if (!this.datalist) {
            this.datalist = new BReactComponent({
                ReactComponent: DataList,
                renderMode: 'append',
            });
            const initialItemId = getInitialId();
            this.datalist.renderTo(el, {
                classes: ['main-datalist'],
                props: {
                    goTo,
                    initialItemId: initialItemId && initialItemId !== ROOT_FOLDER_ID ? initialItemId : '',
                    ...props,
                },
            });
        }
    }

    public destroy(): void {
        this.datalist?.destroy();
        this.datalist = null;
    }

    public show(): void {
        this.datalist?.$el?.show();
        this.datalist?.$el?.parent()?.show();
    }

    public hide(): void {
        this.datalist?.$el?.hide();
        this.datalist?.$el?.parent()?.hide();
    }

    public isExtViewAttaches(): boolean {
        return this.currentModeExt === 'attaches';
    }

    public isExtViewFavorites(): boolean {
        return this.currentModeExt === 'favorites';
    }

    public isExtViewFeed(): boolean {
        return this.currentModeExt === 'feed';
    }

    public isExtViewHome(): boolean {
        return this.currentModeExt === 'home';
    }

    public isExtViewSharedLinks(): boolean {
        return this.currentModeExt === 'shared';
    }

    public isExtViewSharedIncoming(): boolean {
        return this.currentModeExt === 'sharedIncoming';
    }
}
